import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Validators from '../../utils/Validators';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import FormsApi from '../../api/forms';
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  IconButton,
  Switch,
  LinearProgress
} from '@mui/material';
import { Delete } from '@mui/icons-material';

class Form extends Component {
  state = {
    name: '',
    type: this.props.type || 'manual',
    busy: false,
    template: '',
    showErrors: false,
    description: '',
    loading: false,
    fields: [
      {
        id: Date.now(),
        label: '',
        type: '',
        name: '',
        instructions: '',
        required: false,
        hideOnEsign: false,
      }
    ],
    roles: [
      {
        id: Date.now(),
        role_label: '',
        role_type: '',
        signer_name: '',
        signer_email: '',
      }
    ]
  };
  componentDidMount() {
    if (this.props.mode === 'edit') {
      this.setState(
        {
          loading: true
        },
        () =>
          FormsApi.get(this.props.form)
            .then(
              data => {
                this.setState({
                  loading: false,
                  ...data
                });
              },
              error => {
                this.props.showError();
                this.props.onCancel();
              }
            )
            .catch(error => {
              this.props.showError();
              this.props.onCancel();
            })
      );
    }
  }
  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  save = () => {
    if (!this.state.name) {
      this.props.showError('Please enter the name of the form.');
    } else if (
      this.props.forms.find(
        form =>
          form.name.toLowerCase() === this.state.name.toLowerCase() &&
          form.id !== this.props.form
      )
    ) {
      this.props.showError('There is already a form with that name.');
    } else if (this.state.type === 'esign' && !this.state.template) {
      this.props.showError('Please enter the RightSignature Template Id');
    } else if (this.state.type === 'esign' && !this.state.description) {
      this.props.showError('Please enter the form description');
    } else if (
      this.state.type === 'esign' &&
      this.state.fields.find(
        (field, index) =>
          index !== this.state.fields.length - 1 &&
          (!field.name || !field.label || !field.type)
      )
    ) {
      this.setState(
        {
          showErrors: true
        },
        () =>
          this.props.showError(
            'Please provide a value for all the required fields.'
          )
      );
    } else if (
      this.state.type === 'esign' &&
      this.state.roles.find(
        (role, index) =>
          index !== this.state.roles.length - 1 &&
          (!role.role_label || !role.role_type)
      )
    ) {
      this.setState({ showErrors: true })
      this.props.showError('Please provide a value for all the required fields.')
    } else {
      this.setState({ busy: true }, () => {
        const formData = {
          name: this.state.name,
          type: this.state.type,
          fields: this.state.fields,
          description: this.state.description,
          template: this.state.template,
          roles: this.state.roles
        };
        if (this.props.mode === 'edit') {
          FormsApi.updateCustomForm(this.props.form, formData)
            .then(
              form =>
                this.props.onUpdated({
                  _id: this.props.form,
                  id: this.props.form,
                  ...formData
                }),
              error => this.setState({ busy: false }, this.props.showError)
            )
            .catch(error =>
              this.setState({ busy: false }, this.props.showError)
            );
        } else {
          FormsApi.add({
            name: this.state.name,
            type: this.state.type,
            fields: this.state.fields,
            description: this.state.description,
            template: this.state.template,
            roles: this.state.roles
          })
            .then(
              form => this.props.onCreated(form),
              error => this.setState({ busy: false }, this.props.showError)
            )
            .catch(error =>
              this.setState({ busy: false }, this.props.showError)
            );
        }
      });
    }
  };
  handleFieldValueChange = fieldId => {
    return e => {
      let addNewField = false;
      this.setState(
        {
          showError: false,
          field: this.state.fields.map((field, index) => {
            if (field.id === fieldId) {
              addNewField =
                index === this.state.fields.length - 1 &&
                ['label', 'type', 'name'].includes(e.target.name);
              
              if (e.target.name === "hideOnEsign") {
                field[e.target.name] = !field.hideOnEsign
              } else {
                field[e.target.name] =
                  e.target.name === 'required' ? !field.required : e.target.value;
              }
              
            }
            return field;
          })
        },
        () => {
          if (addNewField) {
            this.setState({
              fields: [
                ...this.state.fields,
                {
                  id: Date.now(),
                  label: '',
                  type: '',
                  name: '',
                  instructions: '',
                  required: false,
                  hideOnEsign: false,
                }
              ]
            });
          }
        }
      );
    };
  };
  handleRoleValueChange = roleId => {
    return e => {
      let addNewField = false;
      this.setState(
        {
          showError: false,
          role: this.state.roles.map((role, index) => {
            if (role.id === roleId) {
              addNewField =
                index === this.state.roles.length - 1 &&
                ['role_label', 'role_type', 'signer_name', 'signer_email'].includes(e.target.name);
              role[e.target.name] =
                e.target.name === 'required' ? !role.required : e.target.value;
            }
            return role;
          })
        },
        () => {
          if (addNewField) {
            this.setState({
              roles: [
                ...this.state.roles,
                {
                  id: Date.now(),
                  role_label: '',
                  role_type: '',
                  signer_name: '',
                  signer_email: '',
                }
              ]
            });
          }
        }
      );
    };
  };
  renderFormFields = () => {
    return (
      <div className="col-12">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Field Label</TableCell>
              <TableCell>Field Type</TableCell>
              <TableCell>Merge Field Name</TableCell>
              <TableCell>Instructions for the user</TableCell>
              <TableCell>Mandatory</TableCell>
              <TableCell>Hide on ESign</TableCell>
              <TableCell>Options</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.fields.map((field, index) => (
              <TableRow key={index}>
                <TableCell>
                  <input
                    type="text"
                    disabled={this.state.busy}
                    className="form-control"
                    name="label"
                    value={field.label}
                    onChange={this.handleFieldValueChange(field.id)}
                    placeholder="Field Label"
                  />
                  {index !== this.state.fields.length - 1 &&
                    this.state.showErrors &&
                    !field.label && (
                      <div className="field-required-error">Field required</div>
                    )}
                </TableCell>
                <TableCell>
                  <select
                    name="type"
                    disabled={this.state.busy}
                    className="form-control"
                    value={field.type}
                    onChange={this.handleFieldValueChange(field.id)}
                  >
                    <option value="">Select...</option>
                    <option value="ssn">SSN</option>
                    <option value="account">Account Number</option>
                    <option value="loans">Loans Numbers</option>
                    <option value="dob">Date of Birth</option>
                    <option value="ein">EIN</option>
                    <option value="name">Full Name</option>
                    <option value="text">Text</option>
                    <option value="number">Number</option>
                    <option value="date">Date</option>
                    <option value="phone">Phone Number</option>
                    <option value="email">Email Address</option>
                    <option value="checkbox">Checkbox</option>
                  </select>
                  {index !== this.state.fields.length - 1 &&
                    this.state.showErrors &&
                    !field.type && (
                      <div className="field-required-error">Field required</div>
                    )}
                </TableCell>
                <TableCell>
                  <input
                    type="text"
                    disabled={this.state.busy}
                    className="form-control"
                    name="name"
                    value={field.name}
                    onChange={this.handleFieldValueChange(field.id)}
                    placeholder="Merge Field Name"
                  />
                  {index !== this.state.fields.length - 1 &&
                    this.state.showErrors &&
                    !field.name && (
                      <div className="field-required-error">Field required</div>
                    )}
                </TableCell>
                <TableCell>
                  <input
                    disabled={this.state.busy}
                    type="text"
                    className="form-control"
                    name="instructions"
                    value={field.instructions}
                    onChange={this.handleFieldValueChange(field.id)}
                    placeholder="Instructions for the user"
                  />
                </TableCell>
                <TableCell>
                  <Switch
                    disabled={this.state.busy}
                    checked={field.required}
                    onChange={this.handleFieldValueChange(field.id)}
                    name="required"
                  />
                </TableCell>
                <TableCell>
                  <Switch
                    disabled={this.state.busy}
                    checked={field.hideOnEsign}
                    onChange={this.handleFieldValueChange(field.id)}
                    name="hideOnEsign"
                  />
                </TableCell>
                <TableCell>
                  {index !== this.state.fields.length - 1 && (
                    <IconButton
                      onClick={() =>
                        this.setState({
                          fields: this.state.fields.filter(
                            f => f.id !== field.id
                          )
                        })
                      }
                    >
                      <Delete />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  };
  renderRoleFields = () => {
    return (
      <div className="col-12">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Role Name</TableCell>
              <TableCell>Role Type</TableCell>
              <TableCell>Signer's Name</TableCell>
              <TableCell>Signer's Email</TableCell>
              <TableCell>Options</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.roles.map((role, index) => (
              <TableRow>
                <TableCell>
                  <input
                    type="text"
                    disabled={this.state.busy}
                    className="form-control"
                    name="role_label"
                    value={role.role_label}
                    onChange={this.handleRoleValueChange(role.id)}
                    placeholder="Role Label"
                  />
                  {index !== this.state.roles.length - 1 &&
                    this.state.showErrors &&
                    !role.role_label && (
                      <div className="field-required-error">Field required</div>
                    )}
                </TableCell>
                <TableCell>
                  <select
                    name="role_type"
                    disabled={this.state.busy}
                    className="form-control"
                    value={role.role_type}
                    onChange={this.handleRoleValueChange(role.id)}
                  >
                    <option value="">Select...</option>
                    <option value="employer">Employer</option>
                    <option value="borrower">Borrower</option>
                    <option value="other">Other</option>
                  </select>
                  {index !== this.state.roles.length - 1 &&
                    this.state.showErrors &&
                    !role.role_type && (
                      <div className="field-required-error">Field required</div>
                    )}
                </TableCell>
                {(role.role_label === "other" || role.role_type === "other") ?
                  <>
                    <TableCell>
                      <input
                        type="text"
                        disabled={this.state.busy}
                        className="form-control"
                        name="signer_name"
                        value={role.signer_name}
                        onChange={this.handleRoleValueChange(role.id)}
                        placeholder="Signer's Name"
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="email"
                        disabled={this.state.busy}
                        className="form-control"
                        name="signer_email"
                        value={role.signer_email}
                        onChange={this.handleRoleValueChange(role.id)}
                        placeholder="Signer's Email"
                      />
                    </TableCell>
                  </>
                  :
                  <>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </>
                }
                <TableCell>
                  {index !== this.state.roles.length - 1 && (
                    <IconButton
                      onClick={() =>
                        this.setState({
                          roles: this.state.roles.filter(
                            f => f.id !== role.id
                          )
                        })
                      }
                    >
                      <Delete />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className='line-break' />
        <div className='line-break' />
      </div>
    );
  };
  renderFormOptions = () => {
    if (this.state.type === 'esign') {
      return [
        <div className="col-3">
          <div className="form-group nice">
            <label>RightSignature Template ID</label>
            <input
              disabled={this.state.busy}
              type="text"
              className="form-control"
              value={this.state.template}
              name="template"
              onChange={this.handleInputChange}
              placeholder="RightSignature Template ID"
            />
          </div>
        </div>,
        <div className="col-12">
          <div className="form-group nice">
            <label>Form Description</label>
            <textarea
              className="form-control"
              name="description"
              value={this.state.description}
              onChange={this.handleInputChange}
              placeholder="Enter a description to explain to the user what is this form for."
              disabled={this.state.busy}
              rows={3}
            />
          </div>
        </div>,
        this.renderRoleFields(),
        this.renderFormFields()
      ];
    }
  };
  render() {
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
        maxWidth="sm"
        fullWidth={true}
        fullScreen={this.state.type === 'esign'}
      >
        <DialogTitle id="alert-dialog-title">
          {this.props.mode === 'edit' ? 'Edit Form Settings' : 'Add New Form'}
        </DialogTitle>
        <DialogContent>
          {this.state.loading ? (
            <LinearProgress />
          ) : (
            <DialogContentText id="alert-dialog-description">
              <p>
                {this.props.mode === 'edit'
                  ? 'Use the form below to edit the form settings.'
                  : 'Use the form below to add a new Form to assign to users.'}
              </p>

              <div className="row">
                <div
                  className={this.state.type === 'esign' ? 'col-6' : 'col-12'}
                >
                  <div className="form-group nice">
                    <label>Form Name:</label>
                    <input
                      disabled={this.state.busy}
                      type="text"
                      placeholder="Name of the form"
                      className="form-control"
                      value={this.state.name}
                      onChange={this.handleInputChange}
                      name="name"
                    />
                  </div>
                </div>
                <div
                  className={this.state.type === 'esign' ? 'col-3' : 'col-6'}
                >
                  <div className="form-group nice">
                    <label>Form Type:</label>
                    <select
                      className="form-control"
                      name="type"
                      value={this.state.type}
                      disabled={this.state.busy}
                      onChange={this.handleInputChange}
                    >
                      {/*<option value="attachment">Attachment</option>*/}
                      <option value="document">Documentation</option>
                      <option value="manual">Servicer Form</option>
                      <option value="esign">RightSignature Template</option>
                    </select>
                  </div>
                </div>
                {this.renderFormOptions()}
              </div>
            </DialogContentText>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            disabled={this.state.busy}
            variant="outlined"
            onClick={this.save}
            color="primary"
            autoFocus
          >
            {this.props.mode === 'edit' ? 'Update Form' : 'Save Form'}
          </Button>
          <Button
            disabled={this.state.busy}
            onClick={this.props.onCancel}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
const mapStateToProps = state => {
  return {
    forms: state.data.forms
  };
};
export default connect(
  mapStateToProps,
  {
    showError,
    showMessage
  }
)(Form);
